import type { StorefrontStore } from '@storeo/api-client';

/** M7 · editor de loja (ADR 0018 §5) — os templates leem `store.sections` pra decidir se
 *  mostram Destaque/Catálogo/Depoimento e em que ordem. Cabeçalho e Rodapé não estão na
 *  lista — são sempre ligados (mesmo contrato do P9). */

export function isSectionVisible(store: StorefrontStore, key: string): boolean {
  const found = store.sections.find((s) => s.key === key);
  return found ? found.visible : true; // uma seção ausente da lista nunca deveria acontecer, mas por via das dúvidas mostra
}

/** As chaves na ordem salva pelo parceiro (o array do banco já é a ordem de exibição). */
export function orderedSectionKeys(store: StorefrontStore): string[] {
  return store.sections.map((s) => s.key);
}

/** `store.logoUrl` vem relativo (`/api/store/logo/...`) na API real — precisa do `apiBase` pra
 *  virar URL absoluta. Um preview local (Studio) pode já entregar `blob:`/`http(s):` prontos —
 *  nesse caso passa direto. */
export function logoSrc(logoUrl: string | null, apiBase: string): string | null {
  if (!logoUrl) return null;
  if (/^(https?:|blob:|data:)/.test(logoUrl)) return logoUrl;
  return `${apiBase}${logoUrl}`;
}
